import { render } from "./PageNumber1.vue?vue&type=template&id=6168aa84&scoped=true"
import script from "./PageNumber1.vue?vue&type=script&lang=js"
export * from "./PageNumber1.vue?vue&type=script&lang=js"

import "./PageNumber1.vue?vue&type=style&index=0&id=6168aa84&lang=postcss&scoped=true"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6168aa84"]])

export default __exports__